
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import LogTable from "@/components/logs/LogTable.vue";
import AddBtn from "@/components/generic/buttons/add-btn.vue";
import { Getter } from "vuex-class";
import BuildingOrderModal from "@/components/buildings/BuildingOrderModal.vue";
import UrmetOnboarding from "@/components/buildings/UrmetOnboarding.vue";
import { TranslateResult } from "vue-i18n";
import { UrmetRequestStatus } from "@/utils/buildings";
import ResponsiveBtn from "@/components/generic/buttons/responsive-btn.vue";

const urmetImage = require("@/assets/images/urmet.png");
@Component({
  components: { AddBtn, ResponsiveBtn, LogTable, BuildingOrderModal, UrmetOnboarding },
})
export default class Orders extends Vue {

  @Prop({default: null})
  public building: any;

  @Getter private canDoInEnvCompany: (right: string, companyId?: number) => boolean;

  private loadingLogs: boolean = false;
  private showDialogOrderItem: boolean = false;

  private loadingGetOnboardingStatus: boolean = false;
  private associationStatus: UrmetRequestStatus = null;
  private UrmetRequestStatus = UrmetRequestStatus;
  private urmetImage = urmetImage;
  private urmetOnboardingDialog: boolean = false ;
  private orders: any[] = [];
  private ordersHeaders: object[] = [] ;
  private loadingOrders: boolean = false;
  private totalItems: number = 0;
  private pagination: any = {
    sortDesc: [true],
    sortBy: ["id"],
    mustSort: false,
    multiSort: false,
    page: 1,
    itemsPerPage: 10,
  };

  @Watch("pagination", {deep: true })
  public handlerPagination(val, oldVal) {
    if (val.page !== oldVal.page || val.itemsPerPage !== oldVal.itemsPerPage) {
      this.getOrders();
    }
  }

  public getStatusLabel(status: string): string {
    const statusLabels: { [key: string]: string | TranslateResult } = {
      CREATED: this.$t("orderPage.statusCreated"),
      PAYMENT_MISSING: this.$t("orderPage.paymentStatusMissing"),
      UNDER_CONSTRUCTION: this.$t("orderPage.paymentStatusUnderConstruction"),
      IN_DELIVERY: this.$t("orderPage.statusInDelivery"),
      ERROR: this.$t("orderPage.error"),
    };

    const translatedStatus: TranslateResult = statusLabels[status] || "";
    return translatedStatus.toString();
  }

  private mounted(): void {
    this.ordersHeaders = [
      {value: "BuildingOrder.orderType", text: this.$t("orderPage.orderType"), sortable: false},
      {value: "BuildingOrder.itemType", text: this.$t("orderPage.orderItem"), sortable: false},
      {value: "buyerEmail", text: this.$t("form.email"), sortable: false},
      {value: "status", text: this.$t("orderPage.statusLabel"), sortable: false},
      {value: "updatedAt", text: this.$t("form.updatedAt"), sortable: true},
      {value: "createdAt", text: this.$t("form.createdAt"), sortable: true},
      {value: "trackingNumber", text: this.$t("orderPage.trackingNumber"), sortable: false},
    ];
    this.getOnboardingStatus();
    this.getOrders();
  }
  private getOrders(): Promise<void> {
    this.loadingOrders = true;
    return this.$store.dispatch("buildings/getOrdersByBuildingId", {
      buildingId: this.building.id,
      pagination: this.pagination,
    }).then((res) => {
      this.orders = res.rows;
      this.totalItems = res.count;
    }).finally(() => {
      this.loadingOrders = false;
      this.$emit("loaded");
    });
  }

  /**
   * get the onboarding status by building ID .
   *
   * @return {Promise<void>} Resolves if the onboarding status is fetched successfully, otherwise, it throws an error.
   */
  private async getOnboardingStatus(): Promise<void> {
    this.loadingGetOnboardingStatus = true;
    await this.$store.dispatch("buildings/getOnboardingStatusByBuildingId", {
      buildingId: this.building.id,
    })
      .then((data) => {
        this.associationStatus = data;
      })
      .catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      })
      .finally(() => { this.loadingGetOnboardingStatus = false; });
  }

}
